module.exports = __webpack_public_path__ + "static/media/intro.9dd013e6.mp3";